<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_1"></a>Mrs. Adams in Winter</p>
<div class="pagebreak">
<p class="image"><a id="page_2"></a><img alt="Images" src="images/f0002-01.jpg"/></p>
<p class="caption"><a id="fig03"></a>Charles Robert Leslie, <em>Louisa Catherine Adams</em> (1816);<br/>engraving by G. F. Storm (ca. 1839)<br/> (Courtesy of Private Collection/The Stapleton Collection/The Bridgeman Art Library)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?19aa955e